import React from 'react';
import { Redirect } from 'react-router-dom';
import BankingTypes, { BANKING_INTEGRATION_TYPES } from '../../config/bankingTypes';
import FlinksConnect from './FlinksConnect';
import FlinksAPI from './FlinksAPI';
import PlaidLink from './PlaidLink';
import Inverite from './Inverite';
import FinicityConnect from './FinicityConnect';
import Akoya from './Akoya';
import SmartSelect from './SmartSelect';
import Stub from './Stub';
import SITE_PATHS from '../../config/sitePaths';

function isBankingConfigured(props) {
  return props.location && props.location.state && props.location.state.bankingConfig;
}

// To do APP-2042: Remove usage of "bankingConfig.provider"
export default function BankingContainer(props) {
  const proceedToNext = (skipped) => (props.onNextStep(props.history, { ...props.location.state, skipped }));

  if (!props.location.state) {
    return (
      <Redirect from={SITE_PATHS.BANKING} to={SITE_PATHS.ROOT} />
    );
  }
  if (isBankingConfigured(props)) {
    const {
      provider,
      newProvider,
      type,
      region,
      secondary,
    } = props.location.state.bankingConfig;

    if (
      provider === BankingTypes.TS_API_CAN
      || (newProvider === BankingTypes.FLINKS && type === BANKING_INTEGRATION_TYPES.API)
    ) {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <FlinksAPI {...props} />;
    }

    if (newProvider === BankingTypes.PLAID) {
      return (
        <PlaidLink
          clientId={props.location.state.scoringRequest.clientId}
          requestId={props.location.state.scoringRequest.requestId}
          skipBankingSurvey={props.location.state.skipBankingSurvey}
          createScoringRequest={props.createScoringRequest}
          nextStep={proceedToNext}
        />
      );
    }

    if (newProvider === BankingTypes.INVERITE) {
      return (
        <Inverite
          clientId={props.location.state.scoringRequest.clientId}
          requestId={props.location.state.scoringRequest.requestId}
          skipBankingSurvey={props.location.state.skipBankingSurvey}
          createScoringRequest={props.createScoringRequest}
          onComplete={props.preventRedirectToSocial ? () => {} : proceedToNext}
          webhookData={props.location.state.webhookData}
        />
      );
    }

    if (newProvider === BankingTypes.FINICITY) {
      return (
        <FinicityConnect
          clientId={props.location.state.scoringRequest.clientId}
          requestId={props.location.state.scoringRequest.requestId}
          skipBankingSurvey={props.location.state.skipBankingSurvey}
          createScoringRequest={props.createScoringRequest}
          nextStep={proceedToNext}
        />
      );
    }

    if (newProvider === BankingTypes.AKOYA) {
      return (
        <Akoya
          resumeAuth={props.location.state.resumeAuth}
          scoringRequest={props.location.state.scoringRequest}
          skipBankingSurvey={props.location.state.skipBankingSurvey}
          createScoringRequest={props.createScoringRequest}
          nextStep={proceedToNext}
        />
      );
    }

    if (newProvider === BankingTypes.SMART_SELECT) {
      return (
        <SmartSelect
          region={region}
          secondary={secondary}
          resumeAuth={props.location.state.resumeAuth}
          scoringRequest={props.location.state.scoringRequest}
          skipBankingSurvey={props.location.state.skipBankingSurvey}
          getDataProviderList={props.getDataProviderList}
          nextStep={proceedToNext}
          webhookData={props.location.state.webhookData}
        />
      );
    }

    if (newProvider === BankingTypes.STUB) {
      return (
        <Stub
          nextStep={proceedToNext}
        />
      );
    }
  }

  return (
    <FlinksConnect
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      clientId={props.location.state.scoringRequest.clientId}
      requestId={props.location.state.scoringRequest.requestId}
      skipBankingSurvey={props.location.state.skipBankingSurvey}
      preventRedirectToSocial={props.preventRedirectToSocial}
      onNextStep={proceedToNext}
      webhookData={props.location.state.webhookData}
    />
  );
}
